<template>
  <label class="switch">
    <input
      type="checkbox"
      :value="props.modelValue"
      :checked="props.modelValue"
      @input="emit('update:modelValue', !props.modelValue)"
    >
    <span class="slider round" />
  </label>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  modelValue: {
    type: [String, null, Boolean],
    default: () => "",
    required: true
  }
});

const emit = defineEmits(["update:modelValue"]);
</script>

<style lang="scss" scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 22px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #186AFE;
}

input:focus + .slider {
  box-shadow: 0 0 1px #186AFE;
}

input:checked + .slider:before {
  -webkit-transform: translateX(19px);
  -ms-transform: translateX(19px);
  transform: translateX(19px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>